import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CarouselBullet } from './CarouselBullet';
import { Div } from '../../../layouts';
import { SPACE_L } from './utils/constants';

const CarouselBulletList = ({ count, setSelected, selected, className, trackEvent }) => {
    const bulletArray = [...Array(count).keys()];
    return (
        <Div
            bottom={SPACE_L}
            height={'24px'}
            className={classNames('odf-scroll-custom', 'odf-position-absolute', className)}
        >
            {bulletArray.map((item, index) => (
                <CarouselBullet
                    key={`${index + 1}-bullet`}
                    selected={selected}
                    setSelected={setSelected}
                    value={index}
                    trackEvent={trackEvent}
                />
            ))}
        </Div>
    );
};

CarouselBulletList.propTypes = {
    count: PropTypes.number.isRequired,
    selected: PropTypes.number,
    setSelected: PropTypes.func,
    className: PropTypes.string,
    trackEvent: PropTypes.func.isRequired,
};

CarouselBulletList.defaultProps = {
    selected: 0,
    setSelected: () => {},
    className: '',
};

export { CarouselBulletList };
